class StickyBanner extends HTMLElement {
  #targetHidden = false;
  #footerVisible = false;
  #targetObserver = null;
  #targetElement = null;
  #footerObserver = null;

  connectedCallback() {
    const targetSelector = this.dataset.targetSelector;
    if (!targetSelector) return;

    this.#targetElement = document.querySelector(targetSelector);

    if (!this.#targetElement) return;

    this.#observeTarget();
    this.#observeFooter();
  }

  disconnectedCallback() {
    this.#targetObserver?.disconnect();
    this.#footerObserver?.disconnect();
  }

  #observeTarget() {
    this.#targetObserver?.disconnect();

    this.#targetObserver = new IntersectionObserver(([{ isIntersecting }]) => {
      this.#targetHidden = !isIntersecting;
      this.#updateVisibility();
    });

    this.#targetObserver.observe(this.#targetElement);
  }

  #observeFooter() {
    const footerBottom = document.querySelector('footer.shopify-section--footer .footer--bottom');
    if (!footerBottom) return;

    this.#footerObserver = new IntersectionObserver(([{ isIntersecting }]) => {
      this.#footerVisible = isIntersecting;
      this.#updateVisibility();
    });

    this.#footerObserver.observe(footerBottom);
  }

  #updateVisibility() {
    const show = this.#targetHidden && !this.#footerVisible;

    this.classList.toggle('translate-y-0', show);
    this.classList.toggle('translate-y-full', !show);
    this.classList.toggle('opacity-0', !show);
  }
}

customElements.define('sticky-banner', StickyBanner);
